/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const { tryBabble } = require('app/scripts/lib/try-babble');
const _ = require('underscore');

module.exports.localizeCount = function (key, count, data, options) {
  const { counting = (value) => value } = window.__locale ?? {};
  if (data == null) {
    data = {};
  }
  if (options == null) {
    options = {};
  }
  const args = _.extend({ count: String(count) }, data);
  return tryBabble(['counts', key, counting(count)], args, options);
};
